import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedComponentsModule } from '../../components/sharedComponents.module';
import { SectorsService } from '../sectors/services/sectors.service';
import { SitesService } from './services/sites.service';
import { PipeModule } from '../../pipes';

const components: Type<any>[] = [
]
@NgModule({
	declarations: components,
	imports: [
		CommonModule,
		IonicModule,
		SharedComponentsModule,
		PipeModule,
	],
	exports: components,
	providers: [SitesService, SectorsService]
})
export class SitesModule { }
